import { type TranslationTree } from '@/i18n/types';

export const messages = {
  audience: 'Público',
  audienceFallback: 'Definido pela Bodyprint',
  audienceHint: 'Definido pela Bodyprint',
  plusMembers: 'Membros do Bodyprint+',
  plusHint:
    'Exclusivo Bodyprint+: só membros usam o cupom, e o código é o mesmo para todos. Um print pode vazar o código',
  slots: 'Onde aparece',
  period: 'Período',
} satisfies TranslationTree;
